<div *ngIf="visible" class="trial-strip" role="status">
  <mat-icon class="trial-strip__icon">workspace_premium</mat-icon>
  <span *ngIf="ex?.planType === 'TRIAL' && ex?.trialEnded">Free trial (ended)</span>
  <span *ngIf="ex?.planType === 'TRIAL' && !ex?.trialEnded && endsAtDate">Free trial until {{ endsAtDate | date: 'dd MMM yyyy' }}</span>
  <span *ngIf="ex?.planType === 'TRIAL' && !ex?.trialEnded && !endsAtDate">Free trial</span>
  <span *ngIf="ex?.planType === 'SUBSCRIPTION'">Subscription</span>
</div>
